/**
 * Strips any HTML from the pasted in clipboard text.
 *
 * Args:
 *      pasteEvent (ClipboardEvent): The native paste event
 *
 * Example:
 *      myElem.addEventListener('paste', stripHtml)
 */
export function stripHtml(pasteEvent) {
    let text = '';

    pasteEvent.preventDefault();

    if (pasteEvent.clipboardData || pasteEvent.originalEvent.clipboardData) {
        text = (pasteEvent.originalEvent || pasteEvent).clipboardData.getData('text/plain');
    } else if (window.clipboardData) {
        text = window.clipboardData.getData('Text');
    }

    if (document.queryCommandSupported('insertText')) {
        document.execCommand('insertText', false, text);
    } else {
        document.execCommand('paste', false, text);
    }
}
